/**
 * en-GB messages added by Phase 4 task W32 (docs/PHASE-4-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts.
 */
export const w32EnGB = {
    // Menu entries for the Phase 4 pages
    'nav.forms': 'Forms',
    'nav.setup': 'Set-up guide',
    'nav.domains': 'Custom domains',
    'nav.wallet': 'Google Wallet',
    'nav.platform.wallet': 'Google Wallet',
    'nav.platform.domains': 'Domains',
    // Links added to existing pages
    'tenants.billingLink': 'Billing and invoices',
    'home.start.setup.title': 'Set-up guide',
    'home.start.setup.text': 'A few quick steps to get your first site, groups and sign-in tablet ready.',
    // Visit drawer: ID check result (id-checks module, id_checks.view_result)
    'idResult.title': 'ID check',
    'idResult.none': 'No ID check was recorded for this visit.',
    'idResult.outcome.pass': 'Passed',
    'idResult.outcome.warn': 'Did not pass, reception was told',
    'idResult.outcome.refuse': 'Did not pass, visitor was refused',
    'idResult.outcome.skipped': 'Skipped',
    'idResult.document': 'Document',
    'idResult.method': 'Read by',
    'idResult.method.mrz': 'Machine-readable zone',
    'idResult.method.ocr': 'Text reading',
    'idResult.method.manual': 'Typed by reception',
    'idResult.expiry': 'In date',
    'idResult.name': 'Name matches',
    'idResult.unknown': 'Not checked',
    'idResult.checkedAt': 'Checked',
    'idResult.skipReason': 'Reason skipped',
    'idResult.image': 'A photo of the document is stored and will be deleted on {date}.',
    'idResult.imageNoDate': 'A photo of the document is stored.',
    // Manual sign-in dialog: groups that require ID checks
    'idResult.byEye': 'This group needs an ID check. The portal cannot scan documents, so please check the visitor\'s ID by eye before signing them in.',
};
//# sourceMappingURL=w32.js.map